
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Datim from '@/components/shared/Datim.vue';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import { identityIntegrationsService, ILinkedIdentity } from '@/services/identityIntegrationsService';

@Component({
  name: 'LinkedIdentitiesPanel',
  components: { Datim, PaginationBar },
})
export default class LinkedIdentitiesPanel extends Vue {
  @Prop({ required: true })
  protected integrationId!: number;

  protected loading: boolean = true;
  protected identities: ILinkedIdentity[] = [];
  protected currentPage: number = 1;
  protected total: number = 0;
  protected perPage: number = 15;
  readonly perPageOptions: number[] = [15, 25, 50];

  created() {
    this.fetchPage(1);
  }

  get lastPage(): number {
    return Math.max(1, Math.ceil(this.total / (this.perPage || 15)));
  }

  get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('identityIntegrations.identities.user') as string, value: 'user_id', sortable: false },
      { text: this.$t('identityIntegrations.identities.linkMethod') as string, value: 'link_method', sortable: false },
      { text: this.$t('identityIntegrations.identities.emailAtLinkTime') as string, value: 'email_at_link_time', sortable: false },
      { text: this.$t('identityIntegrations.identities.linkedAt') as string, value: 'linked_at', sortable: false },
    ];
  }

  linkMethodLabel(method: string): string {
    const key = 'identityIntegrations.identities.methods.' + method;

    return this.$te(key) ? (this.$t(key) as string) : method;
  }

  async fetchPage(page: number) {
    this.loading = true;
    try {
      const result = await identityIntegrationsService.identities(this.integrationId, page, this.perPage);
      this.identities = result.data;
      this.currentPage = result.page;
      this.total = result.total;
      this.perPage = result.per_page;
    } finally {
      this.loading = false;
    }
  }

  onPerPageChange(perPage: number) {
    this.perPage = perPage;
    this.fetchPage(1);
  }
}
